import { Link } from "react-router-dom";
import { learnBusinessData } from "../data/enterpriseMenuData";
import { schoolsMenuData } from "../data/schoolsMenuData";
import MegaMenuPanel from "./MegaMenuPanel";

const SchoolsDropdown = ({ isOpen, handleClose, topOffset }) => {
  return (
    <MegaMenuPanel
      isOpen={isOpen}
      handleClose={handleClose}
      eyebrow="LEARN WITH UTIVA"
      title="Seven schools. One practical path forward."
      maxWidth={1240}
      topOffset={topOffset}
      closeButtonClassName="bg-primary text-white hover:bg-secondary hover:text-primary"
      upperSpaceClassName="pt-4 pb-3 px-8  sm:px-4 "
      titleClassName="mt-1 text-lg sm:text-2xl"
      childrenClassName="px-5 sm:px-6"
      footer={
        <>
          <p className="font-poppins text-sm leading-relaxed text-gray">
            <strong className="text-primary">
              Not sure which school is right for you?
            </strong>{" "}
            Answer three quick questions and get a clearer starting point.
          </p>
          <a
            href="/#finder"
            onClick={handleClose}
            className="inline-flex flex-none items-center gap-2 whitespace-nowrap font-poppins text-sm font-extrabold text-primary transition-colors hover:text-secondary"
          >
            Take the career quiz <span aria-hidden="true">→</span>
          </a>
        </>
      }
    >
      <div className="grid lg:grid-cols-schools-mega gap-3 ">
        <section>
          <div className="mb-4 flex items-center justify-between gap-4">
            <h3 className="font-poppins text-base font-bold text-default">
              Career Schools
            </h3>
            <Link
              to="/start"
              className="whitespace-nowrap font-poppins text-sm font-bold text-primary hover:text-secondary"
            >
              View all programs <span aria-hidden="true">↗</span>
            </Link>
          </div>

          <div
            className="grid grid-cols-1 gap-2 border border-[#e1e8f7] p-2.5 sm:grid-cols-2"
            style={{ background: "#f6f8fe", borderRadius: 19 }}
          >
            {schoolsMenuData?.map((school) => (
              <Link
                key={school.id}
                to={school.url}
                onClick={handleClose}
                className={`flex items-center gap-3 rounded-2xl border px-3 py-4 transition-all hover:-translate-y-0.5 hover:shadow-md ${
                  school.featured
                    ? "border-[#171b81] bg-gradient-to-br from-primary via-[#15198b] to-[#292da0] text-white"
                    : "border-transparent bg-white/90 hover:border-primary/30 hover:bg-white"
                } ${school.featured ? "sm:col-span-2" : ""}`}
              >
                <span
                  className={`grid h-12 w-12 flex-none place-items-center font-poppins text-sm font-extrabold ${
                    school.featured
                      ? "rounded-full border-2 border-secondary text-secondary"
                      : "rounded-xl"
                  }`}
                  style={
                    school.featured
                      ? { background: "rgba(255,255,255,0.09)" }
                      : { color: school.codeColor, background: school.codeBg }
                  }
                >
                  {school.code}
                </span>
                <span className="min-w-0 flex-1">
                  <strong
                    className={`block font-poppins ${
                      school.featured
                        ? "text-lg text-white"
                        : "text-base text-primary"
                    }`}
                  >
                    {school.title}
                  </strong>
                  <small
                    className={`block font-poppins text-sm ${
                      school.featured ? "text-white/80" : "text-gray"
                    }`}
                  >
                    {school.desc}
                  </small>
                </span>
                {school.featured && (
                  <span
                    className="hidden flex-none whitespace-nowrap rounded-full border font-poppins text-sm font-extrabold text-secondary sm:inline-flex"
                    style={{
                      borderColor: "rgba(251,175,27,0.55)",
                      background: "rgba(251,175,27,0.1)",
                      padding: "8px 11px",
                    }}
                  >
                    GLOBAL LEADERSHIP
                  </span>
                )}
                <b
                  aria-hidden="true"
                  className={`flex-none font-poppins ${
                    school.featured ? "text-secondary" : "text-primary"
                  }`}
                >
                  →
                </b>
              </Link>
            ))}
          </div>
        </section>

        <aside
          style={{
            color: "var(--ink, #030418)",
            background:
              "linear-gradient(155deg, rgb(255, 250, 240) 0%, rgb(255, 244, 216) 100%)",
            border: "1px solid rgb(238, 219, 169)",
            borderRadius: 20,
            padding: 10,
          }}
        >
          <p
            className="mb-1 font-poppins text-sm font-extrabold tracking-[0.09em]"
            style={{ color: "#8e5e00" }}
          >
            UTIVA FOR BUSINESS
          </p>
          <h3 className="mb-2 font-poppins text-xl font-extrabold leading-tight text-primary">
            Train, hire and pay global teams.
          </h3>

          <div className="grid gap-1">
            {learnBusinessData?.map((item) => {
              const isExternal = item.url.includes("http");
              const content = (
                <>
                  <span
                    className="w-7 flex-none font-poppins text-base font-extrabold"
                    style={{ color: "#8e5e00" }}
                  >
                    0{item.id}
                  </span>
                  <span className=" flex items-center">
                    <span className="">
                      <strong className="block font-poppins text-md leading-tight font-bold text-primary">
                        {item.title}
                      </strong>
                      <small className=" block font-poppins text-sm pr-3 text-gray">
                        {item.desc}
                      </small>
                    </span>
                    <b
                      aria-hidden="true"
                      className="flex-none font-poppins text-primary"
                    >
                      ↗
                    </b>
                  </span>
                </>
              );
              const className =
                "flex items-center gap-3 rounded-2xl border bg-white px-3 py-2 transition-all hover:-translate-y-0.5 hover:shadow-sm";
              const style = { borderColor: "rgba(238,219,169,0.7)" };

              return isExternal ? (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={className}
                  style={style}
                >
                  {content}
                </a>
              ) : (
                <Link
                  key={item.id}
                  to={item.url}
                  onClick={handleClose}
                  className={className}
                  style={style}
                >
                  {content}
                </Link>
              );
            })}
          </div>

          <Link
            to="/business"
            onClick={handleClose}
            className="mt-2 flex items-center justify-center gap-2 rounded-lg bg-primary py-2 font-poppins text-base font-extrabold text-white transition-colors hover:bg-secondary"
          >
            Explore business solutions <span aria-hidden="true">→</span>
          </Link>
        </aside>
      </div>
    </MegaMenuPanel>
  );
};

export default SchoolsDropdown;
